import { Options } from 'vue-class-component';
import {
  ActuatorModalityType,
  SystemControlType,
} from '@/../client-generator/generated-clients/plants';
import ThermoGeneralStep from '../ThermoGeneralStep';

@Options({
  name: 'StepChooseSystemToControlType',
  watch: {
    'roomObject.heatingSystemControlType': function () {
      this.systemToControlChange();
    },
    'roomObject.coolingSystemControlType': function () {
      this.systemToControlChange();
    },
    'roomObject.sharedSystemControlType': function () {
      this.systemToControlChange();
    },
  },
})
export default class StepChooseSystemToControlType extends ThermoGeneralStep {
  public static readonly CHOOSE_TYPE_FIELD = 'chooseTypeField';
  public static readonly CHOOSE_TYPES = {
    HEATING: 'heating',
    COOLING: 'cooling',
    SHARED: 'shared',
  };
  static readonly ONE_TUBES = [
    SystemControlType.OneOnOffValve,
    SystemControlType.OneOpenCloseValve,
    SystemControlType.OneProportionalValve,
  ];
  static readonly FOUR_TUBES = [
    SystemControlType.FourTubesOnOffValve,
    SystemControlType.FourTubesProportionalValve,
    SystemControlType.FourTubesProportionalSpeedControlValve,
  ];
  static readonly TWO_TUBES = [
    SystemControlType.TwoTubesOnOffValve,
    SystemControlType.TwoTubesProportionalValve,
    SystemControlType.TwoTubesProportionalSpeedControlValve,
  ];
  static readonly GATEWAY_MODE = [SystemControlType.GatewayMode];

  modes = {
    [StepChooseSystemToControlType.CHOOSE_TYPES.HEATING]: {
      modelName: 'heatingSystemControlType',
      title: 'AppResource.ChooseTypeHeating',
    },
    [StepChooseSystemToControlType.CHOOSE_TYPES.COOLING]: {
      modelName: 'coolingSystemControlType',
      title: 'AppResource.ChooseTypeCooling',
    },
    [StepChooseSystemToControlType.CHOOSE_TYPES.SHARED]: {
      modelName: 'sharedSystemControlType',
      title: 'AppResource.TypeOfSharedSystem',
    },
  };

  get typeOptions() {
    const tmp: SystemControlType[] = [];
    tmp.push.apply(tmp, StepChooseSystemToControlType.ONE_TUBES);
    switch (this.roomObject.actuatorModalityType) {
      case ActuatorModalityType.Separate:
        tmp.push.apply(tmp, StepChooseSystemToControlType.FOUR_TUBES);
        break;
      case ActuatorModalityType.Shared:
        {
          tmp.push.apply(tmp, StepChooseSystemToControlType.TWO_TUBES);
        }
        break;
      case ActuatorModalityType.Mixed:
      case ActuatorModalityType.None:
        {
          tmp.push.apply(tmp, StepChooseSystemToControlType.TWO_TUBES);
          tmp.push.apply(tmp, StepChooseSystemToControlType.FOUR_TUBES);
        }
        break;
    }
    tmp.push.apply(tmp, StepChooseSystemToControlType.GATEWAY_MODE);
    return tmp;
  }

  get currentMode() {
    return this.modes[
      this.customParams[StepChooseSystemToControlType.CHOOSE_TYPE_FIELD]
    ];
  }

  created() {
    this.systemToControlChange();
  }

  getOptionName(type: SystemControlType) {
    return this.$t(`AppResource.${SystemControlType[type]}`);
  }

  systemToControlChange() {
    this.nextEnabled =
      (this.roomObject as any)[this.currentMode.modelName] !==
      SystemControlType.None;
  }
}
